(function() { /* Start dojo-webpack-plugin extensions */
		function mix(dest, src) { // eslint-disable-line no-unused-vars
			for(var n in src) dest[n] = src[n];
			return dest;
		}

		function toUrl(name, referenceModule) {
			return loaderScope.require.toUrl(name, referenceModule);
		}

		function toAbsMid(name, referenceModule) {
			return loaderScope.require.toAbsMid(name, referenceModule);
		}

		// dojo require function.
		function req(config, dependencies, callback) {
			return contextRequire(config, dependencies, callback, 0, req);
		};

		function createContextRequire(module) { // eslint-disable-line no-unused-vars
			if (!module) return req;
			var moduleId = module.absMid;
			if (!moduleId && req.absMidsById[module.id]) {
				moduleId = req.absMidsById[module.id];
			}
			if (!moduleId) return req;
			var result = function(a1, a2, a3) {
				return contextRequire(a1, a2, a3, moduleId, req);
			};
			for (var p in req) {
				if (req.hasOwnProperty(p)) {
					result[p] = req[p];
				}
			}
			result.toUrl = function(name) {
				return toUrl(name, moduleId ? {mid: moduleId} : null);
			};
			result.toAbsMid = function(name) {
				return toAbsMid(name, moduleId ? {mid: moduleId} : null);
			};

			if (req.undef) {
				result.undef = function(mid) {
					req.undef(mid, moduleId);
				};
			}
			return result;
		}

		function registerAbsMids(absMids) { // eslint-disable-line no-unused-vars
			for (var s in absMids) {
				req.absMids[s] = absMids[s];
				if (!req.absMidsById[absMids[s]]) {
					req.absMidsById[absMids[s]] = s;
				}
			}
		}

		function resolveTernaryHasExpression(expr) { // eslint-disable-line no-unused-vars
			// Expects an expression of the form supported by dojo/has.js loader, except that module identifiers are
			// integers corresponding to webpack module ids.  Returns a module reference if evaluation of the expression
			// using the currently defined features returns a module id, or else undefined.

			var has = findModule("dojo/has", null, false);
			var id = has.normalize(expr, function(arg){return arg;});
			return id && __webpack_require__(id) || undefined;
		}

		function findModule(mid, referenceModule, noInstall, asModuleObj) {
			mid = mid.split("!").map(function(segment) {
				var isRelative = segment.charAt(0) === '.';
				if(isRelative && !referenceModule){
					return segment;
				}
				return toAbsMid(segment, referenceModule ? {mid: referenceModule} : null);
			}).join("!");
			var result;
			if (mid in req.absMids && __webpack_require__.m[req.absMids[mid]]) {
				if (noInstall) {
					var module = __webpack_module_cache__[req.absMids[mid]];
					result = module && (asModuleObj ? module : module.exports);
				} else {
					result = __webpack_require__(req.absMids[mid]);
				}
			}
			if (!result) {
				throw new Error('Module not found: ' + mid);
			}
			return result;
		}

		function dojoModuleFromWebpackModule(webpackModule) { // eslint-disable-line no-unused-vars
			if (webpackModule.absMid) return webpackModule;  // Already converted
			var result = {i:webpackModule.id};
			var id = req.absMidsById[webpackModule.id];
			if (id) {
				result.id = result.absMid = id;
			}
			Object.defineProperty(result, "exports", {
				get: function() { return webpackModule.exports;},
				set: function(value) {webpackModule.exports = value;},
				enumerable: true,
				configurable: true
			});
			return result;
		}

		function contextRequire(a1, a2, a3, referenceModule, req) { // eslint-disable-line no-shadow
			var type = ({}.toString).call(a1);
			if (type === '[object String]') {
				// a3 is passed by require calls injected into dependency arrays for dependencies specified
				// as identifiers (vs. string literals).
				var noInstall = !(a3 === false);
				var m = findModule(a1, referenceModule, noInstall);
				if (typeof m === 'object' && m.__DOJO_WEBPACK_DEFINE_PROMISE__) {
					throw new Error('Module not found: ' + a1);
				}
				return m;
			} else if (type === '[object Object]') {
				throw new Error('Require config is not supported by WebPack');
			}
			if (type === '[object Array]') {
				var modules = [], callback = a2, errors = [];
				a1.forEach(function (mid) {
					try {
						modules.push(findModule(mid, referenceModule));
					} catch (e) {
						errors.push({mid: mid, error: e});
					}
				});
				if (errors.length === 0) {
					if (callback) {
						if (true && isDefinePromise(modules)) { // eslint-disable-line no-undef
							Promise.all(wrapPromises(modules)).then(function(deps) { // eslint-disable-line no-undef
								callback.apply(this, unwrapPromises(deps)); // eslint-disable-line no-undef
							}.bind(this)).catch(function(err){console.error(err);});
						} else {
							callback.apply(this, modules);
						}
					}
				} else {
					var error = new Error("findModules");
					error.src = "dojo-webpack-plugin";
					error.info = errors;
					req.signal("error", error);
				}
				return req;
			} else {
				throw new Error('Unsupported require call');
			}
		}
		req.toUrl = toUrl;
		req.toAbsMid = toAbsMid;
		req.absMids = {};
		req.absMidsById = [];
		req.async = 1;
		function wrapPromises(deps) {
			var result = (Array.isArray(deps) ? deps : [deps]).map(function(m) {
				return (m && typeof m.then === 'function' && !m.__DOJO_WEBPACK_DEFINE_PROMISE__) ? {__DOJO_WEBPACK_PROMISE_VALUE__: m} : m;
			});
			return Array.isArray(deps) ? result : result[0];
		}

		function unwrapPromises(deps) {
			var result = (Array.isArray(deps) ? deps : [deps]).map(function(m) {
				return m && m.__DOJO_WEBPACK_PROMISE_VALUE__ || m;
			});
			return Array.isArray(deps) ? result : result[0];
		}

		function isDefinePromise(values) {
			return (Array.isArray(values) ? values : [values]).some(function(dep) {
				return typeof dep === 'object' && dep.__DOJO_WEBPACK_DEFINE_PROMISE__;
			});
		}

		function asyncDefineModule(defArray, defFactory, module, exports) { // eslint-disable-line no-unused-vars

			function setDefinePromise(promise) {
				promise.__DOJO_WEBPACK_DEFINE_PROMISE__ = true;
				return promise;
			}

			function defModule(deps) {
				module && (module.exports = exports);
				var result =  defFactory.apply(null, deps);
				if (typeof module === 'function') {
					// module is actually a callback function
					module(result);
				} else {
					if (result !== undefined) {
						module.exports = result;
					} else {
						result = module.exports;
					}
				}
				return result;
			}

			if (!isDefinePromise(defArray)) {
				return defModule(defArray);
			} else {
				return setDefinePromise(Promise.all(defArray).then(function(deps) {
					return wrapPromises(defModule(unwrapPromises(deps)));
				}));
			}
		}
	var globalObj = this||window;
	registerAbsMids({
		// "core-js/modules/es.object.to-string.js" = 41539
		// "../internals/to-string-tag-support" = 51694
		// "../internals/well-known-symbol" = 5112
		// "../internals/global" = 17854
		// "../internals/shared" = 72309
		// "../internals/is-pure" = 31913
		// "../internals/shared-store" = 5465
		// "../internals/set-global" = 83505
		// "../internals/has-own-property" = 92597
		// "../internals/function-uncurry-this" = 1702
		// "../internals/function-bind-native" = 34374
		// "../internals/fails" = 47293
		// "../internals/to-object" = 47908
		// "../internals/require-object-coercible" = 84488
		// "../internals/uid" = 69711
		// "../internals/native-symbol" = 30133
		// "../internals/engine-v8-version" = 7392
		// "../internals/engine-user-agent" = 88113
		// "../internals/get-built-in" = 35005
		// "../internals/is-callable" = 60614
		// "../internals/use-symbol-as-uid" = 43307
		// "../internals/define-built-in" = 98052
		// "../internals/create-non-enumerable-property" = 68880
		// "../internals/descriptors" = 19781
		// "../internals/object-define-property" = 3070
		// "../internals/ie8-dom-define" = 64664
		// "../internals/document-create-element" = 80317
		// "../internals/is-object" = 70111
		// "../internals/v8-prototype-define-bug" = 3353
		// "../internals/an-object" = 19670
		// "../internals/to-property-key" = 34948
		// "../internals/to-primitive" = 57593
		// "../internals/function-call" = 46916
		// "../internals/is-symbol" = 52190
		// "../internals/object-is-prototype-of" = 47976
		// "../internals/get-method" = 58173
		// "../internals/a-callable" = 19662
		// "../internals/try-to-string" = 66330
		// "../internals/ordinary-to-primitive" = 92140
		// "../internals/create-property-descriptor" = 79114
		// "../internals/make-built-in" = 56339
		// "../internals/function-name" = 76530
		// "../internals/inspect-source" = 42788
		// "../internals/internal-state" = 29909
		// "../internals/native-weak-map" = 68536
		// "../internals/shared-key" = 6200
		// "../internals/hidden-keys" = 3501
		// "../internals/object-to-string" = 90288
		// "../internals/classof" = 70648
		// "../internals/classof-raw" = 84326
		// "regenerator-runtime/runtime.js" = 35666
		// "core-js/modules/web.dom-collections.for-each.js" = 54747
		// "../internals/dom-iterables" = 48324
		// "../internals/dom-token-list-prototype" = 98509
		// "../internals/array-for-each" = 18533
		// "../internals/array-iteration" = 42092
		// "../internals/function-bind-context" = 49974
		// "../internals/indexed-object" = 68361
		// "../internals/length-of-array-like" = 26244
		// "../internals/to-length" = 17466
		// "../internals/to-integer-or-infinity" = 19303
		// "../internals/array-species-create" = 65417
		// "../internals/array-species-constructor" = 77475
		// "../internals/is-array" = 43157
		// "../internals/is-constructor" = 4411
		// "../internals/array-method-is-strict" = 9341
		// "core-js/modules/es.string.ends-with.js" = 27852
		// "../internals/export" = 82109
		// "../internals/object-get-own-property-descriptor" = 31236
		// "../internals/object-property-is-enumerable" = 55296
		// "../internals/to-indexed-object" = 45656
		// "../internals/copy-constructor-properties" = 99920
		// "../internals/own-keys" = 53887
		// "../internals/object-get-own-property-names" = 8006
		// "../internals/object-keys-internal" = 16324
		// "../internals/array-includes" = 41318
		// "../internals/to-absolute-index" = 51400
		// "../internals/enum-bug-keys" = 80748
		// "../internals/object-get-own-property-symbols" = 25181
		// "../internals/is-forced" = 54705
		// "../internals/to-string" = 41340
		// "../internals/not-a-regexp" = 3929
		// "../internals/is-regexp" = 47850
		// "../internals/correct-is-regexp-logic" = 84964
		// "core-js/modules/es.array.slice.js" = 47042
		// "../internals/create-property" = 86135
		// "../internals/array-method-has-species-support" = 81194
		// "../internals/array-slice" = 50206
		// "core-js/modules/es.string.trim.js" = 73210
		// "../internals/string-trim" = 53111
		// "../internals/whitespaces" = 81361
		// "../internals/string-trim-forced" = 76091
		// "core-js/modules/es.function.name.js" = 68309
		// "core-js/modules/es.json.stringify.js" = 38862
		// "../internals/function-apply" = 22104
		// "core-js/modules/es.array.concat.js" = 92222
		// "core-js/modules/es.array.join.js" = 69600
		// "core-js/modules/es.symbol.js" = 82526
		// "../modules/es.symbol.constructor" = 4032
		// "../internals/object-create" = 70030
		// "../internals/object-define-properties" = 36048
		// "../internals/object-keys" = 81956
		// "../internals/html" = 60490
		// "../internals/object-get-own-property-names-external" = 1156
		// "../internals/array-slice-simple" = 41589
		// "../internals/well-known-symbol-wrapped" = 6061
		// "../internals/define-well-known-symbol" = 97235
		// "../internals/path" = 40857
		// "../internals/symbol-define-to-primitive" = 56532
		// "../internals/set-to-string-tag" = 58003
		// "../modules/es.symbol.for" = 40763
		// "../internals/native-symbol-registry" = 30735
		// "../modules/es.symbol.key-for" = 26620
		// "../modules/es.object.get-own-property-symbols" = 29660
		// "core-js/modules/es.symbol.description.js" = 41817
		// "core-js/modules/es.symbol.iterator.js" = 32165
		// "core-js/modules/es.string.iterator.js" = 78783
		// "../internals/string-multibyte" = 28710
		// "../internals/define-iterator" = 70654
		// "../internals/create-iterator-constructor" = 24994
		// "../internals/iterators-core" = 13383
		// "../internals/object-get-prototype-of" = 79518
		// "../internals/correct-prototype-getter" = 49920
		// "../internals/iterators" = 97497
		// "../internals/object-set-prototype-of" = 27674
		// "../internals/a-possible-prototype" = 96077
		// "core-js/modules/web.dom-collections.iterator.js" = 33948
		// "../modules/es.array.iterator" = 66992
		// "../internals/add-to-unscopables" = 51223
		// "core-js/modules/es.array.from.js" = 91038
		// "../internals/array-from" = 48457
		// "../internals/call-with-safe-iteration-closing" = 53411
		// "../internals/iterator-close" = 99212
		// "../internals/is-array-iterator-method" = 97659
		// "../internals/get-iterator" = 18554
		// "../internals/get-iterator-method" = 71246
		// "../internals/check-correctness-of-iteration" = 17072
		// "core-js/modules/es.regexp.exec.js" = 74916
		// "../internals/regexp-exec" = 22261
		// "../internals/regexp-flags" = 67066
		// "../internals/regexp-sticky-helpers" = 52999
		// "../internals/regexp-unsupported-dot-all" = 9441
		// "../internals/regexp-unsupported-ncg" = 38173
		// "core-js/modules/es.regexp.test.js" = 77601
		// "core-js/modules/es.error.cause.js" = 21703
		// "../internals/wrap-error-constructor-with-cause" = 89191
		// "../internals/proxy-accessor" = 2626
		// "../internals/inherit-if-required" = 79587
		// "../internals/normalize-string-argument" = 56277
		// "../internals/install-error-cause" = 58340
		// "../internals/clear-error-stack" = 77741
		// "../internals/error-stack-installable" = 22914
		// "/home/jenkins/build/workspace/005-dispatch2-build-pipeline/web/node_modules/.cache/dojo/dojo.js" = 37642
	});

	globalObj.require = req;
		(self["webpackChunknavitel_dispatch"] = self["webpackChunknavitel_dispatch"] || []).registerAbsMids = registerAbsMids;

	// expose the Dojo compatibility functions as a properties of __webpack_require__
	if (__webpack_require__.dj && __webpack_require__.dj.name !== 'dojo-webpack-plugin') throw new Error("__webpack_require__.dj name collision.")
	__webpack_require__.dj = {
		name: 'dojo-webpack-plugin',
		r: req,
		c: createContextRequire,
		m: dojoModuleFromWebpackModule,
		h: resolveTernaryHasExpression,
		d: asyncDefineModule,
		w: wrapPromises,
		u: unwrapPromises
	};
	var loaderScope = Object.create(globalObj, {
	   document:{value: globalObj.document},
	});
	Object.defineProperties(loaderScope, {
	   window:{value:loaderScope},
	   global:{value:loaderScope}
	});
	loaderScope.define = loaderScope.require = undefined
	globalObj.dojoConfig = globalObj.dojoConfig || {}
	var userConfig = mix(globalObj.dojoConfig, ({'async':true,'parseOnLoad':false,'tlmSiblingOfDojo':0,'locale':'auto','platform':'web','has':({}),'packages':[({'name':'dojo','location':'/dojo','lib':'.'}),({'name':'dijit','location':'/dijit','lib':'.'}),({'name':'dojox','location':'/dojox','lib':'.'})]}));
	var defaultConfig = ({'hasCache':({'webpack':1,'host-browser':1,'dom':1,'dojo-loader':1,'dojo-has-api':1,'dojo-dom-ready-api':1,'dojo-sniff':1,'dojo-test-sniff':1,'config-deferredInstrumentation':1,'config-tlmSiblingOfDojo':1})});
	var dojoLoader = __webpack_require__(37642);
	dojoLoader.call(loaderScope, userConfig, defaultConfig, loaderScope, loaderScope);
	Object.keys(loaderScope.require.packs).forEach(function(key) {
		var pkg = loaderScope.require.packs[key];
		if ((/(^\/)|(\:)/.test(pkg.main)	// main path is absolute
		    || pkg.main.split('/').reduce(function(acc, pathComp) {
					if (acc < 0 || pathComp === '.') return acc;
					return (pathComp === '..' ? --acc : ++acc);
				}, 0) <= 0) // main path is outside package
				&& typeof pkg.realMain === 'undefined'	// hasn't already been adjusted
		) {
			pkg.realMain = pkg.main;
			pkg.main = '';
		}
	});
	function toAbsMid(name, referenceModule) {
		var absMid = loaderScope.require.originalToAbsMid(name, referenceModule);
		if (absMid.indexOf('/') === absMid.length-1) {
			var pkgName = absMid.substring(0, absMid.length-1);
			var pkg = loaderScope.require.packs[pkgName];
			if (pkg && pkg.realMain) {
				absMid = pkgName;
			}
		}
		return absMid;
	}
	function toUrl(name, referenceModule) {
		var url = loaderScope.require.originalToUrl(name, referenceModule);
		var pkg = loaderScope.require.packs[name];
		if (pkg && pkg.realMain) {
			var parts = url.split('?');
			if (/(^\/)|(\:)/.test(pkg.realMain)) {
				// absolute URL
				parts[0] = pkg.realMain;
			} else {
				// relative URL
				parts[0] = parts[0] + '/' + pkg.realMain;
			}
			url = parts.join('?');
		}
		return url;
	}
	loaderScope.require.originalToAbsMid = loaderScope.require.toAbsMid;
	loaderScope.require.originalToUrl = loaderScope.require.toUrl;
	loaderScope.require.toAbsMid = toAbsMid;
	loaderScope.require.toUrl = toUrl;
	['baseUrl','has','rawConfig','on','signal'].forEach(function(name) {req[name] = loaderScope.require[name]})
	var absMidsWaiting = globalObj["webpackChunknavitel_dispatch"].absMidsWaiting;
	if (absMidsWaiting) {
	   absMidsWaiting.forEach(registerAbsMids);
	   delete globalObj["webpackChunknavitel_dispatch"].absMidsWaiting;
	}
})(); /* End dojo-webpack-plugin extensions */